import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const languageNames = {
    en: " English",
    "en-us": "English (US)",
    "en-gb": "English (UK)",
    "en-gb": "English (UK)",
    ar: " العربيه",
  };

  const currentLanguageCode = i18n.language;
  const currentLanguageName =
    languageNames[currentLanguageCode] || currentLanguageCode;

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  return (
    <>
    <div class="dropdown d-none">
  <button data-mdb-button-init
    data-bs-ripple-init data-mdb-dropdown-init class="btn btn-primary dropdown-toggle"
    type="button"
    id="dropdownMenuButton"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    Dropdown button
  </button>
  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
    <li><a class="dropdown-item" href="#">Action</a></li>
    <li><a class="dropdown-item" href="#">Another action</a></li>
    <li><a class="dropdown-item" href="#">Something else here</a></li>
  </ul>
</div>

    <div className="Lang-cont">
      <div className="dropdown w-fit-content mx-auto">
        <button
          className="show-lang btn btn-secondary dropdown-toggle  text-black fs-16 bg-transparent border-0"
          type="button"
          id="langMenuBtn"
          aria-haspopup="true"
          aria-expanded="false"
          data-bs-toggle="dropdown"
        >
          <i class="fa-solid fa-globe color-white me-2"></i>{" "}
          {currentLanguageName}
        </button>
        <div
          className="dropdown-menu"
          aria-labelledby="langMenuBtn"
          id="local-btns"
        >
          <button
            onClick={() => changeLanguage("en")}
            className="dropdown-item "
          >
            English -En
          </button>
          <button
            id="local-btns"
            onClick={() => changeLanguage("ar")}
            className="dropdown-item "
          >
            العربيه -Ar
          </button>
        </div>
      </div>
    </div>
   </>
  );
};

export default LanguageSwitcher;
